import { gettext } from '@eventbrite/i18n';

const NOT_AUTHORIZED_ERROR = gettext(
    'You do not have permission to access the resource you requested.',
);
const SUBSCRIPTION_NOT_FOUND = gettext(
    'The profile you requested does not exist.',
);
const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);

const USER_HAS_NO_PASSWORD = gettext('USER_HAS_NO_PASSWORD');

export const GENERAL_ERROR_SPEC = {
    NOT_AUTHORIZED: () => NOT_AUTHORIZED_ERROR,
    SUBSCRIPTION_NOT_FOUND: () => SUBSCRIPTION_NOT_FOUND,
    USER_HAS_NO_PASSWORD: () => USER_HAS_NO_PASSWORD,
    default: () => STANDARD_SERVER_ERROR,
};

export const EVENT_IMAGE_PLACEHOLDER_URL =
    'https://cdn.evbstatic.com/s3-build/perm_001/5287e3/django/images/pages/organizations/no-event-image-placeholder-2x.png';
